import { UnauthorizedError } from '@raydiant/api-client-js';
import LoadingModal from '@raydiant/raydial/components/LoadingModal';
import { Redirect, useParams } from 'react-router-dom';
import useCurrentUser from '../../hooks/useCurrentUser';
import * as paths from '../../routes/paths';
import { ActivateRouteState } from '../LocationsPage/components/AddScreenDialog/scannedCode';

const ActivatePage = () => {
  const { code = '' } = useParams<{ code?: string }>();
  const { data: profile, error } = useCurrentUser();

  // A 401 means signed out: stay on this address until the login redirect
  // fires, so login records it as backTo and returns here with the code.
  const signedOut = error instanceof UnauthorizedError;
  if (!profile && (!error || signedOut)) return <LoadingModal isOpen />;

  const state: ActivateRouteState = { activationCode: code };
  return <Redirect to={{ pathname: paths.screens(), state }} />;
};

export default ActivatePage;
